// import { Bot, IBot } from "../bot";
import dayjs from "dayjs";
import { IApikey, IApikeyData } from "./apikey.types";
export class Apikey implements IApikey {
  readonly key?: string;
  created?: number | undefined;
  expire?: number | undefined;
  // bots?: Array<IBot>;

  constructor(data: any) {
    if (data.key) {
      this.key = data.key;
    }

    if (data.data) {
      this.created = data.data.created;
      this.expire = data.data.expire;
    }
  }

  validate(): boolean {
    // if ([null, undefined, ""].indexOf(this.id) >= 0) {
    //     return false;
    // }
    return true;
  }

  data(): IApikeyData {
    return Object.assign({}, this);
  }

  isExpired() {
    if (this.expire) {
      const now = dayjs();
      if (now.unix() > this.expire) {
        return true;
      }
      return false;
    }
    return true;
  }
}
